<div class="d-flex justify-content-center">
  <div class="col-md-12 withpadding">
    <span class="table-title">Process details?</span>
  </div>
  <br><br>
</div>
